module.exports = __webpack_public_path__ + "4838eb76ca2f11e1e0ae567fcd7ed01b.wasm";